import { RouteRecordRaw } from 'vue-router';

const EsiaRedirect = () =>
  import(/* webpackChunkName: "EsiaRedirect" */ 'PortalDir/modules/Auth/pages/EsiaRedirect.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: 'esia-redirect',
    name: 'esia-redirect',
    component: EsiaRedirect,
  },
];

export default routes;
